if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const extras = Array.from(this.form.querySelectorAll('[data-hs-upsell]:checked'));
        if (extras.length) {
          const mainId = formData.get('id');
          const qty = formData.get('quantity') || '1';
          formData.delete('id'); formData.delete('quantity');
          formData.append('items[0][id]', mainId);
          formData.append('items[0][quantity]', qty);
          extras.forEach((extra, index) => {
            const variantSelect = extra.closest('.hs-upsell-item')?.querySelector('[data-hs-upsell-variant]');
            formData.append(`items[${index + 1}][id]`, variantSelect ? variantSelect.value : extra.value);
            const quantityInput = extra.closest('.hs-upsell-item')?.querySelector('[data-hs-upsell-quantity]');
            const extraQuantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
            formData.append(`items[${index + 1}][quantity]`, String(extraQuantity));
          });
        }
        if (this.minicart) {
          formData.append("sections", getUniqueSectionNames(this.minicart.getSectionsToRender()));
        }
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart?.updateSectionContents();
              return;
            }

            this.minicart?.renderContents(response);

            // Keep the minicart check first: window.themeSettings is only emitted
            // by sections/header.liquid, which is also what renders <mini-cart>.
            if (!this.minicart || window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
                // Immediately re-add the 'drawer-open' class to avoid
                // the drawer backdrop from flashing.
                document.body.classList.add("drawer-open");
                setTimeout(() => this.minicart.open(), 200);
              } else {
                this.minicart.open(submitButton);
              }
            }

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: response.items || [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (!window.hsMiniUpsellBound) {
  window.hsMiniUpsellBound = true;
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-hs-mini-extra]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;
    const cart = document.querySelector('mini-cart');
    const status = button.parentElement.querySelector('[data-hs-extra-status]');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Toevoegen…';
    if (status) status.textContent = '';
    try {
      const body = {items: [{id: Number(button.dataset.hsMiniExtra), quantity: 1}], sections_url: location.pathname};
      if (cart) body.sections = getUniqueSectionNames(cart.getSectionsToRender());
      const addUrl = new URL(routes.cart_add_url, location.origin);
      addUrl.pathname = addUrl.pathname.replace(/\.js$/, '') + '.js';
      const response = await fetch(addUrl.toString(), {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Toevoegen is niet gelukt. Probeer opnieuw.');
      if (cart) { cart.renderContents(data); cart.open(); }
      if (status && status.isConnected) status.textContent = 'Sticker toegevoegd aan je winkelwagen.';
      publish(PUB_SUB_EVENTS.cartItemAdd, {source: 'MiniCartUpsell', items: data.items || [data]});
    } catch (error) {
      if (status) status.textContent = error instanceof SyntaxError ? 'De winkelwagen kon niet worden bijgewerkt. Vernieuw de pagina om je winkelwagen te controleren.' : error.message;
    } finally {
      button.disabled = false;
      button.textContent = label;
    }
  }, true);
}

if (!window.hsUpsellVariantBound) {
  window.hsUpsellVariantBound = true;
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-hs-upsell-variant]')) return;
    const item = event.target.closest('.hs-upsell-item');
    const option = event.target.selectedOptions[0];
    item.querySelector('[data-hs-upsell]').value = option.value;
    item.querySelector('b').textContent = '+ ' + option.dataset.price;
    item.querySelector('small').textContent = option.textContent.split(' — ')[0];
  });
}
